export const CONTAINER_FULL_WIDTH = "100vw";

export const ADDITIONAL_TAB_WIDTH = "55vw";

export const FORM_CONTAINER_WIDTH = "768px";
